import styled from '@emotion/styled';
import React from 'react';
import { RiRefreshLine } from 'react-icons/ri';
import { theme } from '../../configs/styled';
import { Col } from '../Col';
import { Divider } from '../Divider';
import { Pagination } from '../Pagination';
import { Row } from '../Row';
import { Select } from '../Select';
import { ISelectOptionProps } from '../Select/Select';
import { Text } from '../Typography';

const TableFooterBase = styled(Row)`
  min-height: ${theme.elementSize.paginationHeight};
  border-top: 1px solid ${theme.palettes.border};
`;

const pageOptions: ISelectOptionProps[] = [
  { title: '10', value: '10' },
  { title: '20', value: '20' },
  { title: '50', value: '50' },
];

export interface ITableFooterProps {
  total: number;
  page: number;
  limit: number;
  onPageChange?: (page: number, pageSize?: number | undefined) => void;
  onClickRefresh?: (event: React.MouseEvent<SVGElement, MouseEvent>) => void;
  onLimitPageChange?: (value: number) => void;
}

const TableFooter: React.FC<ITableFooterProps> = ({
  total,
  page,
  limit,
  onPageChange,
  onClickRefresh,
  onLimitPageChange,
}) => {
  return (
    <TableFooterBase align="middle">
      <Col flex="auto" style={{ marginLeft: theme.spacing.md }}>
        <Text style={{ color: theme.palettes.black50 }}>Rows per page:</Text>
        <Select
          defaultValue={pageOptions && pageOptions[0].value}
          size="middle"
          value={limit}
          bordered={false}
          options={pageOptions}
          onChange={onLimitPageChange}
        />
        <Divider
          style={{
            height: theme.elementSize.navbarDividerHeight,
          }}
          orientation="center"
          type="vertical"
        />
        <RiRefreshLine
          onClick={onClickRefresh}
          style={{
            verticalAlign: 'middle',
            color: theme.palettes.primary,
          }}
          size={20}
        />
      </Col>
      <Col flex="auto" style={{ marginRight: theme.spacing.md }}>
        <Row justify="end">
          <Pagination
            showSizeChanger={false}
            total={total}
            current={page}
            pageSize={limit}
            onChange={onPageChange}
          />
        </Row>
      </Col>
    </TableFooterBase>
  );
};

export default TableFooter;
